import { Box, useMediaQuery } from '@mui/material'
import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Breadcrumb from '@/components/Breadcrumb'
import LoadingScreen from '@/components/LoadingScreen'
import { routeConfig } from '@/routeConfig'
import { buildDashboardRoutes } from '@/routeUtils'

const LazyNotFound = lazy(() => import('@/pages/404'))
const NotFound = (props) => (
    <Suspense fallback={<LoadingScreen />}>
        <LazyNotFound {...props} />
    </Suspense>
)

const NavRoutes = () => {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'))

    return (
        <Box
            sx={[
                {
                    display: 'flex',
                    flex: '1 1 auto',
                    flexDirection: 'column',
                    width: '100%',
                    backgroundColor: 'background.default',
                    minHeight: '100%'
                },
                lgUp ? { py: 6 } : { py: 3 },
                lgUp ? { pt: 6 } : { pt: 1 }
            ]}
        >
            {!lgUp && <Breadcrumb />}
            <Routes>
                {buildDashboardRoutes(routeConfig)}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Box>
    )
}

export default NavRoutes
